import { useSnackbar } from 'notistack';
import {
  selectNotification,
  setNotification,
} from '@store/features/notification';
import {
  selectModalNotification,
  setModalNotification,
} from '@store/features/modal-notification';
import { useEffect } from 'react';
import NotificationModal from '@components/notification-modal';
import { useAppDispatch, useAppSelector } from '@store/hooks';

const AppNotification = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const notification = useAppSelector(selectNotification);
  const modalNotification = useAppSelector(selectModalNotification);

  const onCloseModalNotification = () => {
    dispatch(setModalNotification(null));
  };

  useEffect(() => {
    if (notification) {
      enqueueSnackbar(notification.message, {
        variant: notification.variant,
        autoHideDuration: 5000,
      });
      dispatch(setNotification(null));
    }
  }, [enqueueSnackbar, dispatch, notification]);

  return (
    <NotificationModal
      content={modalNotification?.message}
      open={!!modalNotification}
      title={modalNotification?.title}
      onClose={onCloseModalNotification}
    />
  );
};

export default AppNotification;
